/**
 * Created by 李康飞 on 2017/6/23.
 */
import {getApiUrl} from "./util";
import {handlerDeCryptoText, handlerText} from "@/lib/api";

/**
 * Created by Administrator on 2017/6/1 0001.
 */
let random = Math.round(Math.random() * 10000);
let sign = hex_md5(hex_md5("aAr9MVS9j1") + 1001 + random);
let url = getApiUrl();
let base = {
  channel: "3",
  format: "JSON",
  oper: "127.0.0.1",
  random: random,
  sign: "test",
  spid: "1001",
  test: true,
  service: 'nethos.system.atta.upload'
};


export default function (file, options) {
  // let sign = hex_md5(hex_md5("aAr9MVS9j1") + 1001 + random);
  var form = new FormData();
  for (var item in base) {
    form.append(item, base[item])
  }
  form.append('file', file);
  let promiseXHR = new Promise((resolve, reject) => {
    let xhr = new XMLHttpRequest()
    xhr.open("POST", url)
    xhr.setRequestHeader("sign", sign)
    xhr.upload.onprogress = options.progress;
    xhr.onload = function () {
      if (xhr.readyState == 4 && xhr.status >= 200 && xhr.status < 400) {
        Log('xhr.responseText', xhr.responseText);
        let str = xhr.responseText;
        str = handlerText(str);
        if (!str) str = handlerDeCryptoText(str);
        Log('str', str);
        resolve(str);
      } else {
        reject(xhr.error)
      }
    }
    xhr.send(form)
  })
  return promiseXHR
}





// WEBPACK FOOTER //
// ./src/lib/ajax.js